import { MemberRole } from './memberRoles';

// Non-member data
const DEFAULT_USER_DATA = Object.freeze({
  name: null as null | string,
  gender: null as null | 'Male' | 'Female',
  birthdate: null as null | string,
  role: null as null | MemberRole,
  date: null as null | string,
  lastRefresh: null as null | string,
  puid: null as null | string,
  expiration: null as null | string,
  id: null as null | string,
  email: null as null | string,
  zip: null as null | string,

  isSignedIn: false as boolean,
  isAuthenticated: false as boolean
});

export default DEFAULT_USER_DATA;
